<template>
  <v-dialog
    :value="true"
    persistent
    no-click-animation
    max-width="600"
    overlay-color="primaryblue"
    :overlay-opacity="0.6"
  >
    <section
      class="text-mode-language-notice"
      role="alertdialog"
      aria-modal="true"
      :aria-label="$t('app.dialog.attention_title')"
      aria-describedby="text-mode-language-notice-message"
    >
      <v-icon class="text-mode-language-notice__icon" aria-hidden="true">
        {{ mdiInformationOutline }}
      </v-icon>
      <p
        id="text-mode-language-notice-message"
        class="text-mode-language-notice__message"
      >
        {{ message }}
      </p>
      <div class="text-mode-language-notice__actions">
        <button
          type="button"
          data-analytics-skip
          class="text-mode-language-notice__button text-mode-language-notice__button--switch"
          @click="$emit('switch-to-guided')"
        >
          {{ switchLabel }}
        </button>
        <button
          type="button"
          autofocus
          class="text-mode-language-notice__button text-mode-language-notice__button--continue"
          @click="$emit('continue')"
        >
          {{ continueLabel }}
        </button>
      </div>
    </section>
  </v-dialog>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { mdiInformationOutline } from '@mdi/js';

export default defineComponent({
  name: 'LanguageNoticeDialog',

  props: {
    message: {
      type: String,
      required: true,
    },

    switchLabel: {
      type: String,
      required: true,
    },

    continueLabel: {
      type: String,
      required: true,
    },
  },

  setup() {
    return { mdiInformationOutline };
  },
});
</script>

<style scoped src="../styles/language-notice-dialog.css"></style>
